import AddSeriesButton from './add-series-button';
import AddSeriesContainer from './add-series-container';
import AddSeriesModal from './add-series-modal';
import AddSeriesRadioGroup from './add-series-radio-group';
import AddSeriesContent from './add-series-content';
import AddSeriesTitle from './add-series-title';
import AddSeriesColumn from './add-series-column';
import ActionButtons from './action-buttons';

type AddSeriesType = typeof AddSeriesContainer & {
  Button: typeof AddSeriesButton;
  Modal: typeof AddSeriesModal;
  Column: typeof AddSeriesColumn;
  Content: typeof AddSeriesContent;
  Title: typeof AddSeriesTitle;
  RadioGroup: typeof AddSeriesRadioGroup;
  ActionButtons: typeof ActionButtons;
};

const ComposedAddSeries = AddSeriesContainer as AddSeriesType;

ComposedAddSeries.Button = AddSeriesButton;
ComposedAddSeries.Modal = AddSeriesModal;
ComposedAddSeries.Column = AddSeriesColumn;
ComposedAddSeries.Content = AddSeriesContent;
ComposedAddSeries.Title = AddSeriesTitle;
ComposedAddSeries.RadioGroup = AddSeriesRadioGroup;
ComposedAddSeries.ActionButtons = ActionButtons;

export { ComposedAddSeries as AddSeries };
